<template>
    <div>
        <div class="content-bg">
            欢迎您来到北京电信规划设计院评审现场
        </div>
        <div class="content-form">
            <div class="form-tips">
                感谢您参与本次评审！本次费用为{{ eventInfo?.expertsPrice }}元，如费用无误，请填写以下信息完成签到，如有疑问，请现场联系工作人员。
            </div>

            <van-form @submit="onSubmit">
                <van-field @blur="inputName" :clearable="true" v-model="form.name" name="name" label=""
                    placeholder="请输入您的姓名" />
                <!-- :rules="[{ required: true, message: '请输入您的姓名' }]" -->
                <van-field type="tel" :clearable="true" maxlength="11" v-model="form.phoneNumber" name="phoneNumber"
                    label="" placeholder="请输入您的手机号" />
                <!-- :rules="[{ required: true, message: '请输入您的手机号' }]" -->
                <van-field type="digit" :clearable="true" center v-model="form.smsCode" name="smsCode" label=""
                    placeholder="请输入验证码">
                    <!-- :rules="[{ required: true, message: '请输入验证码' }]" -->
                    <template #button>
                        <van-button plain class="smscode-btn" size="small" :color="smsStatus ? '#aaa' : '#2553E2'"
                            type="info" @click.prevent.stop="getSmsCode()">{{ smsStatus ? smsNum : '发送验证码'
                            }}</van-button>
                    </template>
                </van-field>

                <van-button round block type="info" native-type="submit" class="submit-btn">签到</van-button>
            </van-form>
        </div>
        <van-overlay :show="showLoading">
            <div class="loading-container">
                <van-loading />
            </div>
        </van-overlay>

    </div>
</template>
<script>
import { getEventInfoApi, getUserInfoApi, getSmsCodeApi, submitSignApi } from '@/api/sign'
import { Toast, Dialog } from 'vant';

export default {

    data() {
        const defaultForm = {
            name: null,
            phoneNumber: null,
            smsCode: null
        }
        return {
            defaultForm,
            form: { ...defaultForm },
            eventInfo: {},
            userInfo: {},
            smsStatus: false,
            smsNum: 60,
            showLoading: false
        };
    },
    created() {
        const { id } = this.$route.query
        this.getEventInfo(id)
    },
    methods: {
        onSubmit(values) {
            if (!values.name || !values.smsCode) {
                Dialog.confirm({
                    title: '提示',
                    message: '请填写姓名和验证码',
                    cancelButtonText: '关闭',
                    cancelButtonColor: '#fff',
                    confirmButtonColor: '#2553E2',
                    theme: 'round-button',
                })
                    .then(() => {
                        return
                        // on confirm
                    })
                    .catch(() => {
                        return
                        // on cancel
                    });
                return
            }

            this.showLoading = true

            submitSignApi({
                projectId: this.eventInfo.id,
                expertsId: this.userInfo.id,
                name: values.name,
                phoneNumber: values.phoneNumber,
                smsCode: values.smsCode
            }).then(res => {
                this.showLoading = false
                Dialog.confirm({
                    title: '提示',
                    message: '签到成功',
                    cancelButtonText: '关闭',
                    cancelButtonColor: '#fff',
                    confirmButtonColor: '#2553E2',
                    theme: 'round-button',
                })
                    .then(() => {
                        // on confirm
                    })
                    .catch(() => {
                        // on cancel
                    });
            }).catch(err => {
                this.showLoading = false
                Dialog.confirm({
                    title: '提示',
                    message: err.message,
                    cancelButtonText: '关闭',
                    cancelButtonColor: '#fff',
                    confirmButtonColor: '#2553E2',
                    theme: 'round-button',
                })
                    .then(() => {
                        // on confirm
                    })
                    .catch(() => {
                        // on cancel
                    });
            })
        },
        getSmsCode() {
            if (this.smsStatus) return;

            if (!this.form.name) {
                Toast.fail('请先输入姓名及手机号');
                this.form = { ...this.defaultForm };
                return
            }

            if (!this.form.phoneNumber) {
                Toast.fail('手机号为空');
                return
            }

            this.smsStatus = true

            const interval = setInterval(() => {
                if (this.smsNum > 0) {
                    this.smsNum--;
                } else {
                    clearInterval(interval);
                    this.smsStatus = false;
                    this.smsNum = 60;
                }
            }, 1000);

            getSmsCodeApi({
                phoneNumber: this.form.phoneNumber
            }).then(res => {
                console.log(res);
                Toast.success('发送成功');
            }).catch(err => {
                Toast.fail(err.message);
            })
        },
        getEventInfo(id) {
            getEventInfoApi({ id: id })
                .then(res => {
                    this.eventInfo = res
                }).catch(err => {
                    Toast.fail(err.message);
                })
        },
        inputName() {
            if (!this.form.name) return

            getUserInfoApi({
                name: this.form.name,
            }).then(res => {
                this.userInfo = res
                this.form.phoneNumber = res.phoneNumber
            }).catch(err => {
                Dialog.confirm({
                    title: '提示',
                    message: '您输入的姓名未找到，请核对后重新填写',
                    cancelButtonText: '关闭',
                    cancelButtonColor: '#fff',
                    confirmButtonColor: '#2553E2',
                    theme: 'round-button',
                })
                    .then(() => {
                        this.form = { ...this.defaultForm }
                    })
                    .catch(() => {
                        this.form = { ...this.defaultForm }
                    });
            })
        }
    },
};
</script>
<style lang="scss" scoped>
.content-bg {
    height: 240px;
    background: url(../../assets/images/sign-bg.png) no-repeat center;
    background-size: cover;
    color: #fff;
    padding: 50px 40px 0;
    font-size: 20px;
    line-height: 32px;
}

.content-form {
    margin: 0px 18px;
    margin-top: -100px;
    background: #fff;
    border-radius: 20px;
    padding: 15px 22px 22px;
    font-size: 14px;

    .form-tips {
        margin: 10px 0 30px 0;
    }

    .van-cell {
        border: 1px solid #D7D7D7;
        margin-bottom: 15px;
        border-radius: 6px;
        position: relative;

        .smscode-btn {
            height: 44px;
            width: 80px;
            position: absolute;
            right: -16px;
            top: -10px;
            z-index: 1;
            border-radius: 0 5px 5px 0;
        }
    }

    .submit-btn {
        margin-top: 30px;
    }

    :deep(.van-field__error-message) {
        display: none;
    }
}

.loading-container {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>